<!-- Topbar -->
<!-- h-16 + linka = stejně jako hlavička levého sidebaru -->
<nav class="navbar bg-base-100 h-16 py-0 px-6 border-b border-base-content/10 justify-between">

    <!-- Left: titles and context -->
    <div class="flex-1 min-w-0 flex items-center gap-3">

        <!-- Sidebar toggle: mobile → DaisyUI drawer -->
        <label for="left-sidebar-drawer" class="btn btn-ghost btn-sm btn-square lg:hidden">
            <app-icon icon="app:sidebarToggle" size="md" class="opacity-60" />
        </label>

        <!-- Rozbalení: desktop, jen se sbaleným sidebarem (protějšek sbalení v hlavičce sidebaru) -->
        <button class="btn btn-ghost btn-sm btn-square hidden"
                [class.lg:flex]="isSidebarCollapsed"
                type="button"
                [attr.aria-label]="'common.expand' | translate"
                (click)="toggleSidebar()">
            <app-icon icon="app:sidebarToggle" size="md" class="opacity-60" />
        </button>

        <!-- Back button — vlastní config stránky (setTopbarBack) má přednost; jinak univerzální
             šipka přes in-app historii (NavigationHistoryService), jen na zanořených obrazovkách
             (ne na těch, které jsou jedním klikem z levého menu). -->
        @if (backBtn) {
            <button type="button" class="btn btn-ghost btn-sm btn-square" (click)="backBtn.onClick()">
                <app-icon icon="app:back" size="lg" class="opacity-60" />
            </button>
        } @else if (showDefaultBack) {
            <!-- Pod `md` schovaná: na mobilu stačí systémové zpět (gesto / tlačítko prohlížeče)
                 a v úzké liště je každý čtvereček znát. Vlastní `backBtn` ze setTopbarBack()
                 se NESKRÝVÁ — to není navigace zpět, ale akce stránky („Zrušit“). -->
            <button type="button" class="btn btn-ghost btn-sm btn-square hidden md:inline-flex" (click)="navHistory.back()">
                <app-icon icon="app:back" size="lg" class="opacity-60" />
            </button>
        }

        <!-- Current page / tool title -->
        @if (pageTitle && !chatCtx) {
            <h1 class="page-title truncate min-w-0" [innerHTML]="pageTitle | translate"></h1>
        }

        <!-- Obsah hned za titulkem (např. tužka přejmenování) – LayoutService.setTopbarContentLeft() -->
        @if (topbarContentLeft) {
            <ng-container [ngTemplateOutlet]="topbarContentLeft"></ng-container>
        }

        <!-- Chat context: selected chat name as main title + actions -->
        @if (chatCtx) {
            <div class="flex items-center min-w-0">
                <app-chat-actions-dropdown
                        [isStarred]="chatCtx.isStarred"
                        [title]="chatCtx.title"
                        [dropdownContainer]="null"
                        (actionSelected)="chatCtx.onAction($event)">
                </app-chat-actions-dropdown>
            </div>
        }
    </div>

    <!-- Right: tools + stránkové akce -->
    <div class="flex items-center gap-2">

        <!-- Využití plánu — náhrada full-width karty na dashboardu -->
        <app-usage-chip/>

        <!-- Vlastní akce stránky vpravo – registruje stránka přes LayoutService.setTopbarContentLeft() -->
        @if (topbarContentRight) {
            <ng-container [ngTemplateOutlet]="topbarContentRight"></ng-container>
        }

        <!-- Toggle pravého panelu: pouze mobil (desktop má expand tlačítko ve sbaleném pruhu) -->
        @if (rightPanelService.isVisible() && rightPanelService.config()?.mobileToggle !== false) {
            <button class="btn btn-ghost btn-sm btn-square md:hidden" (click)="rightPanelService.toggle()">
                <app-icon [icon]="rightPanelService.config()?.mobileToggleIcon ?? 'ph:chats-circle'" size="lg" class="opacity-60" />
            </button>
        }

        <!-- Legacy: toggle image history – pouze mobilní viewporty -->
        <button class="btn btn-ghost btn-sm btn-square lg:hidden"
                [class.hidden]="rightPanel?.context !== 'image-history'"
                (click)="rightPanel?.toggle()">
            <app-icon icon="ph:clock-counter-clockwise" size="lg" class="opacity-60" />
        </button>

    </div>
</nav>

<!-- Floating update notification -->
<div class="fixed bottom-0 inset-x-0 px-4 pb-4 z-30 flex pointer-events-none"
     [class.justify-center]="!updateMinimized"
     [class.justify-end]="updateMinimized"
     [class.hidden]="!updateAvailable && !showUpdateCountdown">
    @if (updateMinimized) {
        <!-- Minimized: countdown only, bottom-right -->
        <button class="pointer-events-auto cursor-pointer flex items-center gap-2 gg-popup rounded-full pl-3 pr-4 py-2"
                (click)="updateMinimized = false"
                [title]="'topbar.lang.update-available' | translate">
            <app-icon icon="ph:cloud-arrow-up" size="md" class="text-warning shrink-0" />
            <span class="text-sm font-medium tabular-nums">{{ 'topbar.lang.update-remaining' | translate }} {{ updateCountdownDisplay }}</span>
        </button>
    } @else {
        <div class="pointer-events-auto flex items-center gap-3 gg-popup px-4 py-3 max-w-full">
            <app-icon icon="ph:cloud-arrow-up" size="lg" class="text-warning shrink-0" />
            <div class="leading-tight min-w-0 max-w-[18rem]">
                <div class="text-sm font-medium text-base-content">{{ 'topbar.lang.update-available' | translate }}</div>
                @if (showUpdateCountdown) {
                    <div class="text-sm opacity-60 mt-1">{{ 'topbar.lang.update-remaining' | translate }} {{ updateCountdownDisplay }}</div>
                }
            </div>
            <button class="btn btn-neutral btn-sm shrink-0" (click)="updateNow()">
                {{ 'update.confirmation.dialog.ok' | translate }}
            </button>
            @if (showUpdateCountdown) {
                <button class="btn btn-ghost btn-sm btn-circle shrink-0"
                        (click)="updateMinimized = true"
                        [attr.aria-label]="'common.buttons.close' | translate">
                    <app-icon icon="app:close" size="md" />
                </button>
            }
        </div>
    }
</div>
<!-- end Topbar -->
